
export const URLS = {
  rails_service_blob: '/rails/active_storage/blobs/:signed_id/:filename'
}
export const RAILS_ENV = 'staging';
